export interface NavItem {
  label: string;
  path: string;
}

export const FOAM_NAV: NavItem[] = [
  { label: 'Process', path: '/process' },
  { label: 'Chemicals', path: '/chemicals' },
  { label: 'Costing', path: '/costing' },
  { label: 'Database', path: '/database' },
  { label: 'Test data', path: '/test-data' },
];
